import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../builder';
import { blockElement } from '../../../builder/element-factories';
import { ColumnsGridSection } from './ColumnsGridSection';
import { defaultValues } from '../../Block/Block.builder';

const twoColBlockDefaults = {
  ...defaultValues,
  mediaSrc: 'https://cdn.zappy.app/33e321b4fe5eabfa3accc17810aec145.png',
} as const;

/**
 * @deprecated
 * This component has been deprecated. `BlockGrid` should be used instead.
 */
export default createBuilderModule(withChildren(ColumnsGridSection), {
  name: 'ColumnsSection',
  hideFromInsertMenu: true,
  image: 'https://cdn.zappy.app/95912730bbbb5c8e0cf46127cc12ca67.png',
  inputs: [
    {
      name: 'heading',
      type: 'string',
    },
  ],
  defaultChildren: [
    blockElement({ ...twoColBlockDefaults }),
    blockElement({ ...twoColBlockDefaults }),
  ],
});
